export default [
  {
    name: 'title',
    label: 'Pavadinimas',
    type: 'text',
  },
]